<div class="cart-sidebar-modal">
  <div class="modal-header">
    <h4 class="modal-title text-danger font-weight-bold">Cart</h4>
    <button type="button" class="close" aria-label="Close" (click)="close();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <!-- <mat-accordion>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5>Quotes</h5>
          </mat-panel-title>
        </mat-expansion-panel-header> -->

        <div class="row" *ngIf="isLoading">
          <div class="col-lg-12">
            <spinner></spinner>
          </div>
        </div>

        <ng-container *ngIf="!isLoading && quoteList.length == 0 && orderList.length == 0">
          <div class="row">
            <div class="col-lg-12 mt-4 text-center">
              No records to show
            </div>
          </div>
        </ng-container>
  
        <ng-container *ngIf="quoteList.length > 0">
          <h5>Quotes:</h5>
          <table class="table table-material-like table-scroll">
            <thead>
              <tr>
                <th></th>
                <th class="text-danger font-weight-bold" width="800px"> Item </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of quoteList;let i=index">
                <tr>
                  
                  <td colspan="2">
                    <div class="font-weight-bold text-danger underline mb-3" *ngIf="item.orderTypeId == 4">
                      *** Sample Order
                    </div>
                    <div class="item-container">
                      <div class="left">
  
                        <ng-container>
                          <img class="image-thumbnail" *ngIf="!item.imageShow" src="../../../../../assets/images/Placeholder.png">
                        </ng-container>
  
                        <img class="image-thumbnail" [hidden]="!item.imageShow" src="{{item.image}}" (load)="item.imageShow = true">
                      </div>
                      <div class="right px-2">
                        <div class="description white-space-normal">
                          <strong>Type:</strong> {{item.brand}}
                        </div>
                        <!-- <div *ngIf="item.category && item.categoryValue" class="description white-space-normal">
                          <strong>Categories or Campaigns:</strong> {{item.category?.name}} - {{item.categoryValue?.name}}
                        </div> -->
                        <div class="description white-space-normal">
                          <strong>Operation:</strong> {{item.operation}}
                        </div>
                        <div class="description white-space-normal">
                          <strong>Item:</strong> {{item.productItemNumber}} - {{item.productName}}
                        </div>
                        <div class="description white-space-normal">
                          <strong>Size:</strong>&nbsp;
                          <!-- <ng-container *ngFor="let meas of item.operation.measurement;let i=index;">
                            {{meas.value}}{{meas.prefix}}<span class="ml-2" *ngIf="(i+1 != item.operation.measurement.length) && item.operation.measurement.length != 1">x</span>
                          </ng-container>
                          <ng-container *ngIf="item.operation.wedgeLock"><span class="ml-1 mr-1">-</span>{{item.operation.wedgeLock.value? 'Has Wedge Locks':'No Wedge Locks'}}</ng-container>
                          <ng-container><span class="ml-1 mr-1">-</span>{{item.instruction.name}}</ng-container>
                          <ng-container *ngIf=" item.operation?.id !=1 && item.instruction.isCustom "><span class="ml-1 mr-1">-</span>({{item.instruction.customValue}})</ng-container>
                          <ng-container *ngIf="item.operation.id ==1 && item.instruction.id == 4 "><span class="ml-1 mr-1">-</span>(Disclaimer - *frame sizes will not be accepted)</ng-container> -->
                          <ng-container *ngIf="item.width || item.length">
                            <span *ngIf="item.width">{{item.width}}W</span><span *ngIf="item.width && item.length"> x </span><span *ngIf="item.length">{{item.length}}L</span>
                          </ng-container>
      
                          <ng-container *ngIf="item.isWedgeLock"><span class="ml-1 mr-1" *ngIf="item.width || item.length">-</span>{{item.isWedgeLock ? 'Has Wedge Locks':'No Wedge Locks'}}</ng-container>
                          <ng-container><span class="ml-1 mr-1" *ngIf="item.width || item.length">-</span>{{item.allowance}}</ng-container>
                          <ng-container *ngIf="item.custom"><span class="ml-1 mr-1">-</span>({{item.custom}})</ng-container>
                          <ng-container *ngIf="item.operation == 'Length' && item.allowance == 'Other' "><span class="ml-1 mr-1">-</span>(Disclaimer - *frame sizes will not be accepted)</ng-container>
                        </div>
                        <div class="description white-space-normal">
                          <strong>Qty:</strong>
                          <mat-form-field appearance="outline" style="width: 60px" class="no-bottom-space ml-2">
                            <mat-label>Quantity</mat-label>
                            <input matInput type="number" min="1" value="1" [disabled]="item.isUpdating" [(ngModel)]="item.quantity" (blur)="quantityChange(item)" (click)="$event.target.select()">
                          </mat-form-field>
                        </div>
                        <div class="description white-space-normal mt-3">
                          <strong>Price:</strong> {{item.price | currency}}
                        </div>
                        <div class="description white-space-normal">
                          <strong>Discount:</strong> {{(item.price - item.discountedPrice) | currency }} <i *ngIf="item.discountPercentage">({{item.discountPercentage}}%)</i>
                        </div>
                        <div class="description white-space-normal">
                          <strong>Subtotal:</strong> {{item.subTotal | currency}}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle text-center">
                    <button mat-icon-button (click)="deleteItem(item)" >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
                <!-- Child TRs -->
                <ng-container *ngFor="let  subItem of item.childCartItem;let o=index">
                  <tr class="child">
                    <td class="align-middle text-center text-secondary">
                      <i class="fa fa-level-up fa-rotate-90 fa-2x"></i>
                    </td>
                    <td colspan="2">
                      <div class="item-container">
                        <div class="left">
  
                          <ng-container>
                            <img class="image-thumbnail" *ngIf="!subItem.imageShow" src="../../../../../assets/images/Placeholder.png">
                          </ng-container>
  
                          <img class="image-thumbnail" [hidden]="!subItem.imageShow" src="{{subItem.image}}" (load)="subItem.imageShow = true">
                        </div>
                        <div class="right px-2">
                          <div class="description white-space-normal">
                            <strong>Type:</strong> {{subItem.brand}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Operation:</strong> {{subItem.operation}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Item:</strong> {{subItem.productItemNumber}} - {{subItem.productName}}
                          </div>
                          <div class="description white-space-normal">
                            <div>
                              {{_ns.numberToFraction(subItem.insideWidth)}} W x {{_ns.numberToFraction(subItem.insideLength)}} L - {{subItem.allowance}}
  
                            </div>
                            <!--<div>
                              <span class="font-weight-bold mr-1">Outside Size:</span> {{_ns.numberToFraction(subItem.outsideWidth)}} W x {{_ns.numberToFraction(subItem.outsideLength)}} L - {{subItem.allowance}}
  
                            </div>-->
                          </div>
                          <div class="description white-space-normal">
                            <strong>Qty:</strong> {{subItem.quantity}}
                          </div>
                          <div class="description white-space-normal mt-3">
                            <strong>Price:</strong> {{subItem.price | currency}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Discount:</strong> {{(subItem.price - subItem.discountedPrice) | currency }} <i *ngIf="subItem.discountPercentage">({{subItem.discountPercentage}}%)</i>
                          </div>
                          <div class="description white-space-normal">
                            <strong>Subtotal:</strong> {{subItem.subTotal | currency}}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </ng-container>
  
        <ng-container *ngIf="orderList.length > 0">
          <h5>Orders:</h5>
          <table class="table table-material-like table-scroll">
            <thead>
              <tr>
                <th></th>
                <th class="text-danger font-weight-bold" width="800px"> Item </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of orderList;let i=index">
                <tr>
                  
                  <td colspan="2">
                    <div class="font-weight-bold text-danger underline mb-3" *ngIf="item.orderTypeId == 1">
                      *** Sample Order
                    </div>
                    <div class="item-container">
                      <div class="left">
  
                        <ng-container>
                          <img class="image-thumbnail" *ngIf="!item.imageShow" src="../../../../../assets/images/Placeholder.png">
                        </ng-container>
  
                        <img class="image-thumbnail" [hidden]="!item.imageShow" src="{{item.image}}" (load)="item.imageShow = true">
                      </div>
                      <div class="right px-2">
                        <div class="description white-space-normal">
                          <strong>Type:</strong> {{item.brand}}
                        </div>
                        <!-- <div *ngIf="item.category && item.categoryValue" class="description white-space-normal">
                          <strong>Categories or Campaigns:</strong> {{item.category?.name}} - {{item.categoryValue?.name}}
                        </div> -->
                        <div class="description white-space-normal">
                          <strong>Operation:</strong> {{item.operation}}
                        </div>
                        <div class="description white-space-normal">
                          <strong>Item:</strong> {{item.productItemNumber}} - {{item.productName}}
                        </div>
                        <div class="description white-space-normal">
                          <strong>Size:</strong>&nbsp;
                          <!-- <ng-container *ngFor="let meas of item.operation.measurement;let i=index;">
                            {{meas.value}}{{meas.prefix}}<span class="ml-2" *ngIf="(i+1 != item.operation.measurement.length) && item.operation.measurement.length != 1">x</span>
                          </ng-container>
                          <ng-container *ngIf="item.operation.wedgeLock"><span class="ml-1 mr-1">-</span>{{item.operation.wedgeLock.value? 'Has Wedge Locks':'No Wedge Locks'}}</ng-container>
                          <ng-container><span class="ml-1 mr-1">-</span>{{item.instruction.name}}</ng-container>
                          <ng-container *ngIf=" item.operation?.id !=1 && item.instruction.isCustom "><span class="ml-1 mr-1">-</span>({{item.instruction.customValue}})</ng-container>
                          <ng-container *ngIf="item.operation.id ==1 && item.instruction.id == 4 "><span class="ml-1 mr-1">-</span>(Disclaimer - *frame sizes will not be accepted)</ng-container> -->

                          <ng-container *ngIf="item.width || item.length">
                            <span *ngIf="item.width">{{item.width}}W</span><span *ngIf="item.width && item.length"> x </span><span *ngIf="item.length">{{item.length}}L</span>
                          </ng-container>
      
                          <ng-container *ngIf="item.isWedgeLock"><span class="ml-1 mr-1" *ngIf="item.width || item.length">-</span>{{item.isWedgeLock ? 'Has Wedge Locks':'No Wedge Locks'}}</ng-container>
                          <ng-container><span class="ml-1 mr-1" *ngIf="item.width || item.length">-</span>{{item.allowance}}</ng-container>
                          <ng-container *ngIf="item.custom"><span class="ml-1 mr-1">-</span>({{item.custom}})</ng-container>
                          <ng-container *ngIf="item.operation == 'Length' && item.allowance == 'Other' "><span class="ml-1 mr-1">-</span>(Disclaimer - *frame sizes will not be accepted)</ng-container>
                        </div>
                        <div class="description white-space-normal">
                          <strong>Qty:</strong>
                          <mat-form-field appearance="outline" style="width: 60px" class="no-bottom-space ml-2">
                            <mat-label>Quantity</mat-label>
                            <input matInput type="number" min="1" value="1" [disabled]="item.isUpdating" [(ngModel)]="item.quantity" (blur)="quantityChange(item)" (click)="$event.target.select()">
                          </mat-form-field>
                        </div>
                        <div class="description white-space-normal mt-3">
                          <strong>Price:</strong> <ng-container *ngIf="!item.isUpdating"> {{item.price | currency}}</ng-container>
                          <i *ngIf="item.isUpdating" class="spinner-grow spinner-grow-sm" style="margin-left: 40px !important"></i>
                        </div>
                        <div class="description white-space-normal">
                          <strong>Discount:</strong> <ng-container *ngIf="!item.isUpdating"> {{(item.price - item.discountedPrice) | currency }} <i *ngIf="item.discountPercentage">({{item.discountPercentage}}%)</i></ng-container>
                          <i *ngIf="item.isUpdating" class="spinner-grow spinner-grow-sm" style="margin-left: 15.6px !important"></i>
                        </div>
                        <div class="description white-space-normal">
                          <strong>Subtotal:</strong> <ng-container *ngIf="!item.isUpdating"> {{item.subTotal | currency}}</ng-container>
                          <i *ngIf="item.isUpdating" class="spinner-grow spinner-grow-sm" style="margin-left: 20px !important"></i>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="align-middle text-center">
                    <button mat-icon-button (click)="deleteItem(item)" >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
                <!-- Child TRs -->
                <ng-container *ngFor="let  subItem of item.childCartItem;let o=index">
                  <tr class="child">
                    <td class="align-middle text-center text-secondary">
                      <i class="fa fa-level-up fa-rotate-90 fa-2x"></i>
                    </td>
                    <td colspan="2">
                      <div class="item-container">
                        <div class="left">
  
                          <ng-container>
                            <img class="image-thumbnail" *ngIf="!subItem.imageShow" src="../../../../../assets/images/Placeholder.png">
                          </ng-container>
  
                          <img class="image-thumbnail" [hidden]="!subItem.imageShow" src="{{subItem.image}}" (load)="subItem.imageShow = true">
                        </div>
                        <div class="right px-2">
                          <div class="description white-space-normal">
                            <strong>Type:</strong> {{subItem.brand}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Operation:</strong> {{subItem.operation}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Item:</strong> {{subItem.productItemNumber}} - {{subItem.productName}}
                          </div>
                          <div class="description white-space-normal">
                            <div>
                               {{_ns.numberToFraction(subItem.insideWidth)}} W x {{_ns.numberToFraction(subItem.insideLength)}} L - {{subItem.allowance}}
  
                            </div>
                            <!--<div>
                              <span class="font-weight-bold mr-1">Outside Size:</span> {{_ns.numberToFraction(subItem.outsideWidth)}} W x {{_ns.numberToFraction(subItem.outsideLength)}} L - {{subItem.allowance}}
  
                            </div>-->
                          </div>
                          <div class="description white-space-normal">
                            <strong>Qty:</strong> {{subItem.quantity}}
                          </div>
                          <div class="description white-space-normal mt-3">
                            <strong>Price:</strong> {{subItem.price | currency}}
                          </div>
                          <div class="description white-space-normal">
                            <strong>Discount:</strong> {{subItem.price - subItem.discountedPrice | currency }} <i *ngIf="subItem.discountPercentage">({{subItem.discountPercentage}}%)</i>
                          </div>
                          <div class="description white-space-normal">
                            <strong>Subtotal:</strong> {{subItem.subTotal | currency}}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </ng-container>
      <!-- </mat-expansion-panel>
    </mat-accordion> -->
  </div>
  
  <div class="modal-footer  text-center">
    <span class="mr-2 text-danger font-weight-bold">Subtotal: {{(getListSubTotalPrice(orderList) + getListSubTotalPrice(quoteList)) | currency}}</span>
    <button type="button" class="btn btn-outline-danger" (click)="viewCart()" [disabled]="isLoading || (quoteList.length == 0 && orderList.length == 0)">View cart</button>
    <button type="button" class="btn btn-danger" (click)="checkout()" [disabled]="isLoading || (quoteList.length == 0 && orderList.length == 0)">Checkout</button>
  </div>  
</div>
